import { defineProviderCapability } from "./define-provider-capability";

// Google Sign-In OAuth client IDs + URL scheme used by the mobile app for
// "Sign in with Google". Values live in mobile/<env-instance> Doppler.
const mobileDopplerEnv = (name: string) => ({
  name,
  availability: "boot" as const,
  source: {
    kind: "doppler" as const,
    project: "mobile",
    config: "environment" as const,
  },
  mobileEasArtifact: "eas-json" as const,
});

export const googleAuth = defineProviderCapability("googleAuth", {
  mobileOauth: {
    scope: "runtime",
    environments: {
      local: { mode: "managed" },
      preview: { mode: "managed" },
      production: { mode: "managed" },
    },
    env: [
      mobileDopplerEnv("EXPO_PUBLIC_IOS_CLIENT_ID"),
      mobileDopplerEnv("EXPO_PUBLIC_IOS_SCHEME"),
      mobileDopplerEnv("EXPO_PUBLIC_WEB_CLIENT_ID"),
    ],
  },
});
